import React from "react";

import DomainSettingsStore from "../../stores/DomainSettingsStore";

function withData(Component) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this._onStoreChange = this._onStoreChange.bind(this);

      this.state = {
        domainSettingsData: DomainSettingsStore.getState(),
      };
    }

    componentDidMount() {
      this.storeUnsubscribe = DomainSettingsStore.listen(this._onStoreChange);
    }

    componentWillUnmount() {
      this.storeUnsubscribe();
    }

    _onStoreChange() {
      this.setState({ domainSettingsData: DomainSettingsStore.getState() });
    }

    render() {
      return <Component domainSettingsData={this.state.domainSettingsData} {...this.props} />;
    }
  };
}

export default withData;
